import { BiteLogSimpleEvent } from './bite_log_simple_event.js';

export function stringFromEnum(event: BiteLogSimpleEvent): string {
  switch (event) {
    case BiteLogSimpleEvent.Unrecognized:
      return 'unrecognized';
    case BiteLogSimpleEvent.SimpleStatusOk:
      return 'simple status ok';
  }
}
